import { RefObject, useEffect } from 'react';

export const useCloseModal = <T extends HTMLElement>(
  ref: RefObject<T>,
  close: () => void,
  listener: keyof DocumentEventMap,
  closeOnoutSideClick:boolean
) => {
  const handleClickOutside = (event: Event) => {
    if (
      ref.current &&
      event.target instanceof Node &&
      !ref.current.contains(event.target)   && closeOnoutSideClick===true
    ) {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener(listener, handleClickOutside);
    return () => {
      document.removeEventListener(listener, handleClickOutside);
    };
  }, []);
};